<div class="outer-container">
    <!-- CardConnect Form -->
    <div
        *ngIf="!isStripeEnabled"
        class="inner-container"
        (keyup.enter)="submitForm()"
    >
        <div [ngClass]="{ hidden: !isCreditCardIframeLoaded }">
            <mat-form-field class="card-number-field">
                <iframe
                    qa="cc-number-iframe"
                    [src]="creditCardTokenizerUrl"
                    frameborder="0"
                    scrolling="no"
                    (load)="creditCardIframeLoaded()"
                ></iframe>
                <input
                    matInput
                    [hidden]="true"
                    formControlName="creditCardToken"
                />
                <mat-error>Invalid card number</mat-error>
            </mat-form-field>
        </div>
        <div *ngIf="!isCreditCardIframeLoaded">
            <mat-form-field class="card-number-field fake-field">
                <input matInput placeholder="Card Number" readonly />
            </mat-form-field>
        </div>
        <div class="multi-field-row">
            <mat-form-field>
                <input
                    matInput
                    placeholder="MM/YY"
                    mask="00/00"
                    [dropSpecialCharacters]="true"
                    [formControl]="creditCardExpiration"
                />
                <mat-error *ngIf="creditCardExpiration.errors?.required"
                    >Expiration required</mat-error
                >
                <mat-error *ngIf="!creditCardExpiration.errors?.required"
                    >Invalid expiration</mat-error
                >
            </mat-form-field>
            <mat-form-field class="cvv-field">
                <input
                    matInput
                    placeholder="CVV"
                    mask="9{4}"
                    [dropSpecialCharacters]="true"
                    [formControl]="creditCardCvv"
                />
                <mat-error *ngIf="creditCardCvv.errors?.required"
                    >CVV code required</mat-error
                >
                <mat-error *ngIf="!creditCardCvv.errors?.required"
                    >Invalid cvv code</mat-error
                >
            </mat-form-field>
            <mat-form-field class="billing-zip-code">
                <input
                    matInput
                    placeholder="Billing Zip Code"
                    mask="0{5}"
                    [dropSpecialCharacters]="true"
                    [formControl]="creditCardZip"
                />
                <mat-error *ngIf="creditCardZip.errors?.required"
                    >Zip code required</mat-error
                >
                <mat-error *ngIf="!creditCardZip.errors?.required"
                    >Invalid zip code</mat-error
                >
            </mat-form-field>
        </div>
        <div>
            <mat-form-field>
                <input
                    matInput
                    placeholder="Name on Card"
                    maxlength="40"
                    [formControl]="creditCardClientName"
                />
                <mat-error *ngIf="creditCardClientName.errors?.required"
                    >Name required</mat-error
                >
            </mat-form-field>
        </div>
    </div>

    <!-- Stripe Manual Component -->
    <div *ngIf="isStripeEnabled" class="stripe-container">
        <ols-stripe-manual
            [amount]="summary?.itemTotal || 0"
            [currency]="currencyCode"
        ></ols-stripe-manual>
    </div>

    <!-- Stripe Surcharge Banner -->
    <div
        *ngIf="shouldShowSurchargeBanner()"
        qa="stripe-surcharge-banner"
        style="margin-top: 16px; margin-bottom: 16px"
    >
        A <strong>{{ surchargeSettings.surchargeRate }}%</strong> surcharge will
        be added to the amount paid by the card once processed.
    </div>
</div>
